import * as Sentry from "@sentry/react";
import { getCookie } from "@/api";
import { CSRF_TOKEN_COOKIE_NAME } from "@/shared/constants";
import axios, { AxiosError } from "axios";
import { SERVICE_URL } from "@/shared/config";

const instance = axios.create({
  baseURL: `${SERVICE_URL}/ko`,
  withCredentials: true,
  xsrfCookieName: CSRF_TOKEN_COOKIE_NAME,
  xsrfHeaderName: "X-CSRFToken"
});

instance.interceptors.request.use(
  config => {
    const csrfToken = getCookie(CSRF_TOKEN_COOKIE_NAME);
    if (!config.headers["X-Csrftoken"] && csrfToken) {
      config.headers["X-Csrftoken"] = csrfToken;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    if (error instanceof AxiosError) {
      const method = error.config?.method;
      const url = error.config?.url;
      const params = error.config?.params;
      const requestData = error.config?.data;
      const headers = error.config?.headers;
      const responseData = error.response?.data;
      const status = error.response?.status;

      Sentry.setContext("API Request Detail", {
        method,
        url,
        params,
        data: requestData,
        headers
      });

      Sentry.setContext("API Response Detail", {
        status,
        data: responseData
      });

      if (status) {
        if (status === 400) {
          Sentry.withScope(scope => {
            scope.setTag("type", "api");
            scope.setLevel("warning");

            Sentry.captureException(error);
          });
        }

        if (status === 401) {
          Sentry.withScope(scope => {
            scope.setTag("type", "api");
            scope.setLevel("warning");

            Sentry.captureException(error);
          });
        }

        if (status === 403) {
          if (!(url === "/maru/user/api/user" && method === "get")) {
            Sentry.withScope(scope => {
              scope.setTag("type", "api");
              scope.setLevel("warning");

              Sentry.captureException(error);
            });
          }
        }

        if (status === 404) {
          Sentry.withScope(scope => {
            scope.setTag("type", "api");
            scope.setLevel("warning");

            Sentry.captureException(error);
          });
        }

        if (status >= 500) {
          Sentry.withScope(scope => {
            scope.setTag("type", "api");
            scope.setLevel("error");

            Sentry.captureException(error);
          });
        }
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
